import React from "react";
import { Alert, Spin, Tag } from "antd";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { describeFilters, hasActiveFilters } from "../../constants/subgroup-filters";
import { BannerWrapper } from "./styled";

/**
 * Tells the reader which subgroup the charts below are showing.
 * Rendered only while a subgroup filter is active.
 */
const SubgroupBanner = ({ loading, empty, sampleSize, sampleSizePediatric, mapNote }) => {
  const { t } = useTranslation();
  const filters = useSelector((state) => state?.data?.subgroupFilters) || {};
  if (!hasActiveFilters(filters)) return null;

  const description = describeFilters(filters, t);
  const counts = [];
  if (sampleSize !== null && sampleSize !== undefined) {
    counts.push(`${t("subgroup.obstetricCases")} = ${sampleSize}`);
  }
  if (sampleSizePediatric) {
    counts.push(`${t("subgroup.pediatricCases")} = ${sampleSizePediatric}`);
  }

  return (
    <BannerWrapper data-testid="subgroup-banner">
      <Tag color="blue" className="label">
        {t("subgroup.filtering")}: {description}
        {counts.length > 0 && ` — ${counts.join(", ")}`}
        {loading && <Spin size="small" className="spin" />}
      </Tag>
      {empty && !loading && <Alert type="warning" showIcon message={t("subgroup.noData")} className="notice" />}
      {mapNote && <span className="map-note">{t("subgroup.mapNotFiltered")}</span>}
    </BannerWrapper>
  );
};

export default SubgroupBanner;
